<template>
    <div>
        <create-user-check-phone ref="verifyCreateMoible" />

        <div class="page-container">
            <v-page-header
                title="批量修改员工信息"
                :back="{
                    title: '组织架构',
                    goBack,
                }"
            />
            <div class="import-dialog">
                <div class="fix download-step">
                    <div class="fl download-step1">
                        <span>1</span>下载组织架构文件并按格式修改员工信息
                        <div v-tip:white.hover class="reply-list_icon" />
                    </div>
                </div>
                <div class="step1_remind">
                    <div>
                        <span>请勿在组织架构文件中新增员工或修改员工的企点账号</span>
                    </div>
                    <div>
                        <span>员工拥有的能力取决于权限角色，请先创建好</span>
                        <a href="/mng/role" target="_blank">权限角色</a>
                        <span>，再在模板中填写</span>
                    </div>
                </div>
                <div class="down_excel">
                    <v-button v-show="exportStatus" status="default" @click="downLoadFile">
                    下载组织架构文件
                    </v-button>
                    <div v-show="!exportStatus" class="div_botton">
                        <div />
                        <span>导出文件生成中</span>
                    </div>
                    <!-- <v-button status="default" class="div_loading">导出文件生成中</v-button> -->
                </div>
                <v-tip ref="white" kind="large" placement="bottom">
                    <div class="replay-list_hover">
                        <div class="reply-list_background" />
                    </div>
                </v-tip>
                <div class="ovh">
                    <div class="download-step2">
                    <span>2</span>上传修改好的员工信息表
                    </div>
                </div>
                <div class="upload-textarea">
                    <v-uploader
                        ref="fileUpload"
                        :url="uploadUrl"
                        :draggable="true"
                        :with-credentials="true"
                        kind="area"
                        name="fileform"
                        :show-list="false"
                        form-key="lbf-file-upload"
                        class="upload-text"
                        :data="paramsData"
                        :size-limit="'10MB'"
                        type-limit="*.xlsx;"
                        @fileschange="filesChange"
                        @start="startImport"
                        @success="onSuccessUpload"
                        @error="showErrorUpload"
                    >
                        <div class="upload-textarea-tips">
                            <div v-show="fileShow" class="upload-success-show">
                                <div v-show="!fileUploading" class="upload_icon" />
                                <div class="uploading-info">
                                    {{ fileImport
                                    }}<a href="javascript:" ondragstart="return false" class="ml10">重新上传</a>
                                </div>

                                <div v-show="!fileUploading" class="upload-textarea-info">
                                    <div>将文件拖拽到此区域</div>
                                    <div>文件小于10M，仅支持xlsx文件，请将Excel文档保存为兼容模式</div>
                                </div>
                            </div>

                            <div v-show="!fileShow" class="upload-error-show">
                                <div v-show="!fileUploading" class="upload_icon" />
                                <div v-show="uploadError" class="uploading-info">
                                    {{ fileImport
                                    }}<a href="javascript:" ondragstart="return false" class="ml10">重新上传</a>
                                </div>
                                <div v-show="uploadError" class="upload-error-message">
                                    <div class="upload-fl">
                                        <v-icon name="v-error" />
                                        <span class="upload-error-text ml5">{{ uploadErrorMsg }}</span>
                                    </div>
                                </div>
                                <div v-show="!uploadError" class="upload-textarea-info">
                                    <div>将文件拖拽到此区域</div>
                                    <div>文件小于10M，仅支持xlsx文件，请将Excel文档保存为兼容模式</div>
                                </div>
                                <div v-show="!uploadError" class="upload-textarea-botton">
                                    <v-button :class="{ export_disabled: remainSum === 0 }" status="default">
                                    上传文件
                                    </v-button>
                                </div>
                            </div>
                        </div>
                    </v-uploader>
                </div>
            </div>
        </div>
        <v-footer-actionbar class="importMembers-download-button">
            <template slot="footer-actionbar-button">
                <v-button status="primary" size="large" :disabled="importDisabled" @click="handleImport">导入并修改员工信息</v-button>
            </template>
        </v-footer-actionbar>
    </div>
</template>

<script>
/* eslint-disable prefer-destructuring */

import { Icon } from 'vhtml-ui';
import catchErr from 'src/utils/catchError';
import cookie from '@/utils/cookie';
import Axios from 'axios';
import { envDomain } from '@/utils/domainConfig';
import createUserCheckPhone from '@/components/create-user-check-phone';
import { VERIFY_STATUS } from '@/components/create-user-check-phone/constants';
import { sleep } from '@/components/create-user-check-phone/utils';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
const axios = Axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});
export default {
    components: {
        createUserCheckPhone,
    },
    data() {
        return {
            // downTemplateUrl: '/mng/org/editUserTemplate',
            exportOrg: `${envDomain.gateway}/v1/mng/org/exportUserList`,
            exportResult: `${envDomain.gateway}/v1/mng/org/importExportCheckStatus?taskType=2`,
            uploadUrl: `${envDomain.gateway}/v1/mng/org/checkEditUserFile?type=upload`,
            importUrl: `${envDomain.gateway}/v1/mng/org/importEditUser?type=upload`,
            exportCheckStatusUrl: `${envDomain.gateway}/v1/mng/org/importExportCheckStatus?taskType=1`,
            downloadImportExportResultUrl: '/mng/org/downloadEditUserFailed',
            paramsData: { _bqq_csrf: cookie.get('_bqq_csrf') },
            fileShow: false, // 导入文件内容显示
            fileImport: '',
            uploadError: false,
            downloadFlag: true,
            fileUploading: false,
            successCount: 0, // 成功导入数
            errorFile: [], // 错误文件内容
            importName: '', // 导入文件名
            importResponse: {},
            fileType: '', // 文件类型
            importDisabled: true, // 批量导入按钮置灰
            uploadErrorMsg: '文件超出规定大小，请确保文件小于20M', // 错误信息内容
            file: {},
            taskType: 1,
            exportStatus: true,
            checkTimeout: 0,
            sms_mobile: '',
            sms_code: '',
        };
    },
    computed: {},
    mounted() {
        document.getElementsByClassName('v-uploader__core')[0].accept = '.xlsx';
    },
    methods: {
        goBack() {
            window.location.href = '/mng/org';
        },
        downLoadFile() {
            // const url = this.downTemplateUrl;
            // window.open(url);
            this.exportStatus = false;
            this.getExportStatus()
                .then((list) => {
                    if (list.code === 0) {
                        this.getExportResult();
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        getExportStatus() {
            return new Promise((resolve, reject) => {
                this.$ajax
                    .crossPost(this.exportOrg)
                    .then((res) => {
                        if (res && res.code === 0) {
                            resolve(res);
                        } else {
                            reject(new Error(res.message));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getExportResult() {
            this.exportDownLoadResult()
                .then((list) => {
                    if (list.data.taskStatus === 2) {
                        window.open(list.data.result_file_url);
                        this.exportStatus = true;
                    } else if (list.data.taskStatus === 0) {
                        clearTimeout(this.checkTimeout);
                        this.checkTimeout = setTimeout(() => {
                            this.getExportResult();
                        }, 3000);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        exportDownLoadResult() {
            return new Promise((resolve, reject) => {
                this.$ajax
                    .crossGet(this.exportResult)
                    .then((res) => {
                        if (res && res.code === 0) {
                            resolve(res);
                        } else {
                            reject(new Error(res.message));
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        // 开始上传
        startImport(val) {
            this.file = val;
            this.fileUploading = true;
            this.uploadError = false;
            this.fileImport = val.name;
            this.fileType = val.raw.type;
        },
        // 上传成功
        onSuccessUpload(val) {
            this.fileShow = true;
            this.fileUploading = false;
            this.uploadError = false;
            const res = val.origin.data;
            if (res.code === 0) {
                let message = res.message || '成功';
                if (res.data && res.data.tip) {
                    message = res.data.tip;
                }
                this.$message.success(message);
                this.importDisabled = false;
                this.fileImport = val.file.name;
            } else {
                this.fileShow = false;
                this.uploadError = true;
                if (res.data) {
                    this.downloadFlag = true;
                } else {
                    this.downloadFlag = false;
                }
                this.uploadErrorMsg = res.message;
                this.importDisabled = true;
            }
        },
        // 错误显示
        showErrorUpload(val) {
            this.fileUploading = false;
            this.uploadError = true;
            const { response, message } = val.origin;
            if (message === 'File size exceed') {
                this.uploadErrorMsg = '文件超出规定大小，请确保文件小于10M';
            } else if (message === 'File type invalid') {
                this.uploadErrorMsg = '文件类型错误，请上传.xlsx格式的文件';
            } else {
                try {
                    this.uploadErrorMsg =                        response.data.message || `错误代码: ${val.origin.status} 上传文件错误，请重新上传 `;
                } catch (err) {
                    this.uploadErrorMsg = `错误代码: ${val.origin.status} 上传文件错误，请重新上传 `;
                }
            }
            this.downloadFlag = false;
            this.importDisabled = true;
        },
        // 文件更换
        filesChange() {
            this.fileShow = false;
        },
        async handleImport() {
            try {
                this.importDisabled = true;
                this.openImport = false;
                this.status = 'importing';
                const formdata = new FormData();

                formdata.append('lbf-file-upload', this.file.raw, this.file.name);
                formdata.append('_bqq_csrf', cookie.get('_bqq_csrf'));
                // formdata.append('sms_mobile', this.sms_mobile);
                formdata.append('sms_code', this.sms_code);

                axios
                    .post(this.importUrl, formdata)
                    .then((data) => {
                        if (data.data.code === 0) {
                            this.status = this.successCount >= 0 ? 'success' : 'failure';
                            this.errorFile = this.status === 'failure' ? data.data.errorfile : '';
                            this.exportCheckStatus();
                        } else {
                            this.uploadErrorMsg = data.message;
                            throw data.data;
                        }
                    })
                    .catch(async (err) => {
                        const { message, code } = err;

                        // 接口报异常重置异常码，避免多次使用同一个验证码提交
                        this.sms_code = '';

                        if (code === 20041) {
                            // 没绑定手机号
                            this.$refs.verifyCreateMoible.mobileVerify('');
                            this.importDisabled = false;
                            return;
                        } if (code === 20040) {
                            // 手机号放在message
                            this.sms_mobile = message;


                            // 需要校验手机号
                            const res = await this.$refs.verifyCreateMoible.mobileVerify(this.sms_mobile);
                            console.log('校验结果', res);
                            const { verifyStatus, sms_code, sms_mobile } = res;

                            if (verifyStatus === VERIFY_STATUS.hasSendCode && sms_code && sms_mobile) {
                                // 已经发送验证码了
                                this.sms_code = sms_code;
                                this.sms_mobile = sms_mobile;
                                await sleep(300);
                                this.handleImport();
                                return;
                            } if (verifyStatus === VERIFY_STATUS.cancel) {
                                this.creating = false;
                                this.importDisabled = false;

                                return;
                            }
                        }

                        this.importDisabled = false;
                        this.$message.error(catchErr.catchErr(err));
                    });
            } catch (e) {
                console.log('校验异常', e);
            }
        },
        exportCheckStatus() {
            window.location.href = '/mng/org/importMembersChangeProcess';
        },
    },
};
</script>

<style lang="less">
@import '../styles/app';
</style>
